import { Injectable } from "@angular/core";
import { IAddEditPort } from "src/app/Models/Interface/Port/add-edit-port";
import { DataService } from "../DataService/data.service";
import { Observable } from "rxjs";
import { APIName } from "../../Models/APIEndPoints/APIName";
import { IPagination } from "src/app/Models/Interface/Pagination/pagination";
import { IActivateClient } from "src/app/Models/Interface/Client/activate-client";
import { IBaseDataList } from "src/app/Models/Interface/Base/base-data-list";
import { HttpParams } from "@angular/common/http";
import { IPort } from "src/app/Models/Interface/Port/port";
import { IBaseData } from "src/app/Models/Interface/Base/base-data";
import { IPortDetails } from "src/app/Models/Interface/Port/port-details";
import { IActivatePort } from "src/app/Models/Interface/Port/activate-port";
import { IPortFinancial } from "src/app/Models/Interface/Port/port-financial";
import { IPortForPager } from "src/app/Models/Interface/Port/port-for-pager";

@Injectable({
  providedIn: "root",
})
export class PortService {
  portOBJ = {} as IAddEditPort;
  isFilterEnabled: boolean = false;
  pagination = {
    skip: 0,
    take: 15,
    pagesCount: 0,
    inPageNumber: 1,
  } as IPagination;
  search: string = "";
  filter: string = "";
  countryId: number = 0;
  activate = {} as IActivatePort;
  financialsPortOBJ = {} as IPortFinancial;

  constructor(private dataService: DataService) {}

  addPort(): Observable<boolean> {
    let formData = new FormData();
    if (this.portOBJ.Picture) {
      formData.append(
        "Picture",
        this.portOBJ.Picture,
        this.portOBJ.Picture.name
      );
    }
    formData.append("Address", this.portOBJ.Address);
    formData.append("Name", this.portOBJ.Name);
    formData.append(
      "AdministrationFees",
      String(this.portOBJ.AdministrationFees)
    );
    formData.append(
      "AdministrationFeesCurrencyId",
      String(this.portOBJ.AdministrationFeesCurrencyId)
    );
    formData.append(
      "ShippingFeesCurrencyId",
      String(this.portOBJ.ShippingFeesCurrencyId)
    );
    formData.append("ShippingFees", String(this.portOBJ.ShippingFees));
    formData.append("CountryId", String(this.portOBJ.CountryId));
    return this.dataService.post(APIName.port.add, formData);
  }

  getAllPorts(): Observable<IBaseData<IBaseDataList<IPort[]>>> {
    let params = new HttpParams();
    // @ts-ignore
    params = params.append("Skip", this.pagination.skip);
    params = params.append("Take", this.pagination.take);
    params = params.append("SearchKeyword", this.search);
    params = params.append("CountryId", this.countryId ? this.countryId : 0);
    params = params.append("IsFilterEnabled", this.isFilterEnabled);
    params = params.append("statusCode", this.filter);
    return this.dataService.getWithParams(APIName.port.getAll, params);
  }

  getPortDetails(id: number): Observable<IPortDetails> {
    let params = new HttpParams();
    if (id) params = params.append("portId", id);
    return this.dataService.getWithParams(APIName.port.getDetails, params);
  }

  editPort(): Observable<any> {
    let formData = new FormData();
    if (this.portOBJ.Picture) {
      formData.append(
        "Picture",
        this.portOBJ.Picture,
        this.portOBJ.Picture.name
      );
    }
    formData.append("Id", String(this.portOBJ.Id));
    formData.append("Address", this.portOBJ.Address);
    formData.append("Name", this.portOBJ.Name);
    formData.append(
      "AdministrationFees",
      String(this.portOBJ.AdministrationFees)
    );
    formData.append("ShippingFees", String(this.portOBJ.ShippingFees));
    formData.append("CountryId", String(this.portOBJ.CountryId));
    formData.append(
      "AdministrationFeesCurrencyId",
      String(this.portOBJ.AdministrationFeesCurrencyId)
    );
    formData.append(
      "ShippingFeesCurrencyId",
      String(this.portOBJ.ShippingFeesCurrencyId)
    );
    formData.append("PortStatusId", String(this.portOBJ.PortStatusId));
    return this.dataService.post(APIName.port.update, formData);
  }

  onActivate(): Observable<any> {
    return this.dataService.post(APIName.port.activate, this.activate);
  }

  onUpdateFinancials(): Observable<boolean> {
    return this.dataService.post(
      APIName.port.financialUpdate,
      this.financialsPortOBJ
    );
  }

  getPortForMariHub(countryId: number | null): Observable<IPort[]> {
    let params = new HttpParams();
    if (countryId) {
      params = params.append("countryId", countryId);
    }
    return this.dataService.getWithParams(
      APIName.port.getPortsForMarihub,
      params
    );
  }

  getAllPortsWithoutPagination(): Observable<IBaseDataList<IPortForPager[]>> {
    return this.dataService.get(APIName.port.allPorts);
  }
}
